import React from 'react';
import { Iconfont } from '@umu/umu-design';

const DEFAULT_PROPS = {
    maxUploadConcurrent: 5,
    onBeforeUpload: (file: File, accept?: string) => {
        const ext = file.name.split('.').pop() || '';
        if (accept) {
            const acceptedTypes = accept.split(',').map((type) => type.trim());
            return acceptedTypes.includes('.' + ext);
        }
        return true;
    },
    getIconElementByFileType: (fileType: string) => {
        switch (fileType) {
            case 'ppt':
            case 'pptx':
                return <Iconfont className="upload-icon-file-ppt" type="FilePPT" />;
            case 'xls':
            case 'xlsx':
            case 'xlsm':
                return <Iconfont className="upload-icon-file-excel" type="FileXls" />;
            case 'doc':
            case 'docx':
                return <Iconfont className="upload-icon-file-doc" type="FileWord" />;
            case 'pdf':
                return <Iconfont className="upload-icon-file-pdf" type="FilePdf" />;
            case 'mp4':
                return <Iconfont className="upload-icon-file-mp4" type="Mp4" />;
            default:
                return <span className="upload-icon-file-default" />;
        }
    },
};

export { DEFAULT_PROPS };
